import { TableTextFilter } from 'uikit';

import { useMemo } from 'react';

export const useAddOtherFilter = (elements: any[]) =>
    useMemo(() => {
        if (!elements) {
            return [];
        }

        return [
            {
                id: 'name',
                name: 'Наименование:',
                field: 'name',
                filterer: () => true,
                component: {
                    name: TableTextFilter,
                    props: {
                        withSearch: true,
                        items: elements.map((item: { name: string }) => ({ name: item.name, value: item.name })),
                    },
                },
            },
        ];
    }, [elements]);
